import { render, staticRenderFns } from "./HelpUs107.vue?vue&type=template&id=814bacc4&scoped=true&"
import script from "./HelpUs107.vue?vue&type=script&lang=js&"
export * from "./HelpUs107.vue?vue&type=script&lang=js&"
import style0 from "./HelpUs107.vue?vue&type=style&index=0&id=814bacc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814bacc4",
  null
  
)

export default component.exports